module.exports = __webpack_public_path__ + "static/media/pdf.810f02f1.svg";